module.exports = __webpack_public_path__ + "img/cmp-analysis.b62dbf61.png";